import _slicedToArray from "/Users/janjelschen/apploft/tln/tln_lottonds_backend/deployments/firebase/apploft_cloud_react_modules/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

/**
 * FormatString.js
 *
 * Copyright (c) apploft. GmbH
 */

/**
 * Returns `[value]` or `[key, value]` tuple matching `name` in `format`.
 *
 * @param {any[]} format An array of format objects.
 * @param {string} name The name (left-side of colon) of the format desired format string.
 */
function matching(format, name) {
  if (!Array.isArray(format) || format.length < 1) {
    return [];
  }

  var firstMatching = format.find(function (o) {
    var value = o[name];
    return typeof value === 'string';
  });

  if (!firstMatching) {
    return [];
  }

  var str = firstMatching[name];
  console.assert(typeof str === 'string');

  var _str$split = str.split('='),
      _str$split2 = _slicedToArray(_str$split, 2),
      key = _str$split2[0],
      value = _str$split2[1];

  if (typeof key !== 'string' || typeof value !== 'string') {
    return [str];
  }

  return [key, value];
}

export { matching };